import {Component, Input, OnInit} from '@angular/core';
import {CustomFormControl} from '../CustomFormControl';
import {UntypedFormGroup} from '@angular/forms';

@Component({
  selector: 'app-radio-lg-button',
  templateUrl: './radio-lg-button.component.html',
  styleUrls: ['./radio-lg-button.component.scss']
})
export class RadioLgButtonComponent implements OnInit {

  @Input() control: CustomFormControl;
  @Input() formGroup: UntypedFormGroup;

  onSelectionChange(id: string): void {
    this.control.element.option = id;
  }
  ngOnInit(): void {
  }
}
